import EmptyState from '../empty-state/empty-state';
import errorImgUrl from '../search-error.svg';

import messages from './search-error.i18n';

export const SearchUnknownError = () => (
  <EmptyState
    headingMessage={messages.error}
    descriptionMessage={messages.unknownErrorDescription}
    imageSrc={errorImgUrl}
  />
);
